<template>
  <HeadlineComponent>Report: T-Shirt Größen</HeadlineComponent>
  <table class="table pagebreak">
    <thead>
      <tr>
        <th>Größe</th>
        <th>Benötigte Shirts</th>
        <th>Gesamt Shirts</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(shirtSize, name) of sizes" :key="name">
        <td>{{ name }}</td>
        <td>{{ shirtSize.neededCount }}</td>
        <td>{{ shirtSize.count }} ({{ shirtSize.percentage }}%)</td>
      </tr>
    </tbody>
  </table>

  Insgesamt werden {{ neededCount }} T-Shirt(s) benötigt.<br />
  Bei kompletter Neubestellung würden stand jetzt {{ total }} T-Shirt(s)
  benötigt werden.
</template>

<script>
import userService from "@/services/user.service.js";
import { mapActions } from "pinia";
import { useAlertsStore } from "@/stores/alerts.js";
import { shirtSizeName } from "@/enums/shirtsizes.js";
import HeadlineComponent from "@/components/HeadlineComponent.vue";
import * as Sentry from '@sentry/vue';

export default {
  name: "ShirtsView",
  data() {
    return {
      sizes: [],
      neededCount: 0,
      total: 0,
    };
  },
  methods: {
    ...mapActions(useAlertsStore, { addAlert: "add" }),
  },
  async beforeRouteEnter(to, from, next) {
    let sizes = {
      S: { count: 0, neededCount: 0 },
      M: { count: 0, neededCount: 0 },
      L: { count: 0, neededCount: 0 },
      XL: { count: 0, neededCount: 0 },
      XXL: { count: 0, neededCount: 0 },
      "3XL": { count: 0, neededCount: 0 },
    };
    let total = 0;
    let neededCount = 0;
    try {
      let response = await userService.index();
      for (let user of response.data) {
        sizes[shirtSizeName(user.shirt_size)].count++;
        total++;
        if (!user.has_shirt) {
          sizes[shirtSizeName(user.shirt_size)].neededCount++;
          neededCount++;
        }
      }
      for (let size in sizes) {
        sizes[size].percentage =
          Math.round((sizes[size].count / total) * 10000) / 100;
      }
    } catch (e) {
      if (e) {
        Sentry.captureException(e);
        useAlertsStore().add(
          "danger",
          "Es ist was unerwartetes schief gegangen.."
        );
        window.scrollTo(0, 0);
      }
    }
    next((vm) => {
      vm.total = total;
      vm.neededCount = neededCount;
      vm.sizes = sizes;
    });
  },
  components: { HeadlineComponent },
};
</script>

<style scoped></style>
